import React from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { Checkbox } from "../../../../../components/checkbox/Checkbox";
import { ProtectionStatus } from "./protectionEditor.constants";

import "./ProtectionEditorFilters.scss";

interface ProtectionEditorFiltersProps {
  filterStatus: ProtectionStatus[];
  onChange: (option: ProtectionStatus) => void;
  disabled: boolean;
}

export const ProtectionEditorStatusFilters = ({
  filterStatus,
  onChange,
  disabled,
}: ProtectionEditorFiltersProps) => {
  return (
    <div className={"protection-editor-filters"}>
      <Checkbox
        onChange={() => onChange(ProtectionStatus.Blocked)}
        checked={_.includes(filterStatus, ProtectionStatus.Blocked)}
        label={
          <FormattedMessage id="protection_editor_checkbox_blocked_label" />
        }
        aria-labelledby="blocked_filter"
        disabled={disabled}
      />
      <Checkbox
        onChange={() => onChange(ProtectionStatus.Allowed)}
        checked={_.includes(filterStatus, ProtectionStatus.Allowed)}
        label={
          <FormattedMessage id="protection_editor_checkbox_allowed_label" />
        }
        aria-labelledby="allowed_filter"
        disabled={disabled}
      />
    </div>
  );
};
